import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import "./General.css";

const FeesCharges = () => {
  return (
    <div className="General-page">
      <div className="General-section">
        <div>
          <h1>Fees & Charges</h1>
        </div>
        <div>
          <Accordion defaultActiveKey="0" flush className="General-background">
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h6 className="accordion-text">How much do you charge?</h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                OVest is completely free (Zero SMS fees, zero account
                maintenance fees).
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default FeesCharges;
